import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableFooter,
  Typography,
} from '@mui/material';

const ArrayTable = ({
  headers = [],
  rows = [],
  stickyHeader = false,
  dense = false,
  getRowId,
  tableProps = {},
  containerProps = {},
  cellAlign = 'left',
  footer,
}) => {
  return (
    <TableContainer
      component={Paper}
      sx={{ padding: 2, overflowX: 'auto' }}
      {...containerProps}
    >
      <Table
        sx={{ tableLayout: 'fixed', width: '100%', minWidth: 800 }}
        size={dense ? 'small' : 'medium'}
        {...tableProps}
        stickyHeader={stickyHeader}
      >
        <TableHead>
          <TableRow>
            {headers.map((label) => (
              <TableCell
                key={`${label}`}
                align={cellAlign}
                sx={{ padding: '12px 16px' }}
              >
                {label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row}>
              {headers.map((_, colIndex) => (
                <TableCell
                  key={row[colIndex]}
                  align={cellAlign}
                  sx={{ padding: '12px 16px' }}
                >
                  {Array.isArray(row)
                    ? row[colIndex] !== undefined
                      ? row[colIndex]
                      : ''
                    : ''}
                </TableCell>
              ))}
              {Array.isArray(row) &&
                row.length > headers.length &&
                row.slice(headers.length).map((extraCell) => (
                  <TableCell
                    key={extraCell}
                    align={cellAlign}
                    sx={{ padding: '12px 16px' }}
                  >
                    {extraCell}
                  </TableCell>
                ))}
            </TableRow>
          ))}
        </TableBody>
        {Array.isArray(footer) && (
          <TableFooter>
            <TableRow>
              {headers.map((_, idx) => (
                <TableCell
                  key={`footer-${idx}`}
                  align={cellAlign}
                  sx={{
                    padding: '12px 16px 0 16px',
                    borderBottom: 'none',
                  }}
                >
                  <Typography fontWeight={600}>{footer[idx] ?? ''}</Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableFooter>
        )}
      </Table>
    </TableContainer>
  );
};

export default ArrayTable;
